import { Heading } from "@freightsimple/ui-core/Typography/Heading";
import type { Shipment } from "@freightsimple/generated-dashboard-openapi-client/models/Shipment";

interface DeliveryContactPageProp {
  shipment: Shipment;
}

export function ModifyShipmentDeliveryContactPage(
  _props: DeliveryContactPageProp,
) {
  return <Heading level={1}>Delivery Contact</Heading>;
}
